import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { faCheck, faFile, faFileUpload, faPencilAlt, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { Store } from '@ngrx/store';
import { BsModalService } from 'ngx-bootstrap/modal';
import {
    checkParticipantInModal,
    removeParticipant,
    removeParticipantForm,
    updateCurrentlyEditedParticipant,
} from '../../../store/actions/form.actions';
import { FormsState } from '../../../store/state/pace-forms.state';
import { ParticipantCopy } from '../../../types/participant-copy';
import { AddParticipantComponent } from '../add-participant/add-participant.component';

@Component({
    selector: 'pace-forms-participant-list-entry',
    templateUrl: './participant-list-entry.component.html',
    styleUrls: ['./participant-list-entry.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ParticipantListEntryComponent {
    @Input()
    public participant: ParticipantCopy;

    public readonly faCheck = faCheck;
    public readonly faPencil = faPencilAlt;
    public readonly faFileUpload = faFileUpload;
    public readonly faFile = faFile;
    public readonly faTrashAlt = faTrashAlt;
    public constructor(
        private readonly store: Store<FormsState>,
        private readonly modalService: BsModalService,
    ) {}

    public deleteParticipant(): void {
        this.store.dispatch(
            removeParticipant({
                participant: this.participant.id,
            }),
        );
    }

    public participantChecked(): void {
        this.store.dispatch(
            checkParticipantInModal({
                participant: this.participant.id,
            }),
        );
    }

    public editParticipant(): void {
        this.store.dispatch(
            updateCurrentlyEditedParticipant({
                id: this.participant.id,
            }),
        );
        this.modalService.show(AddParticipantComponent, {
            backdrop: 'static',
            class: 'modal-md',
            ariaLabelledBy: 'add-participant-modal-title',
        });
    }

    public deleteParticipantForm(): void {
        this.store.dispatch(
            removeParticipantForm({
                participant: this.participant.id,
            }),
        );
    }
}
